module.exports = __webpack_public_path__ + "img/640-92ccf5.png";